/* Produktseite Unikat — gallery lightbox, tabs, variant logic.
   Loaded from main-product-unikat.liquid via {{ 'produktseite-unikat.js' | asset_url | script_tag }}.
   Vanilla JS, no jQuery. */
(function () {
  // ---- Collect media (must come BEFORE tile click handlers) ----
  var tiles = document.querySelectorAll('.tile[data-lb]');
  var MEDIA = Array.from(tiles).map(function (t) {
    var img = t.querySelector('img');
    var vid = t.querySelector('video');
    if (t.getAttribute('data-lb-type') === 'video' && vid) {
      return {
        type: 'video',
        src: vid.getAttribute('src'),
        poster: vid.getAttribute('poster') || '',
        ton: t.getAttribute('data-ton') === '1',
        alt: 'Werkstatt-Video'
      };
    }
    return {
      type: 'image',
      src: img ? img.getAttribute('src') : '',
      alt: img ? (img.getAttribute('alt') || '') : ''
    };
  });

  // ---- Lightbox ----
  var lb = document.getElementById('lightbox');
  var lbRail = document.getElementById('lbRail');
  var lbMedia = document.getElementById('lbMedia');
  var lbStage = document.getElementById('lbStage');
  var lbClose = document.getElementById('lbClose');
  var lbZoomIn = document.getElementById('lbZoomIn');
  var lbZoomOut = document.getElementById('lbZoomOut');
  var lbZoomDot = document.getElementById('lbZoomDot');
  var ZOOM_STEPS = [1, 1.5, 2.25, 3];
  var lbState = { idx: 0, zoom: 0, panX: 0, panY: 0 };

  function buildRail() {
    if (!lbRail) return;
    lbRail.innerHTML = '';
    MEDIA.forEach(function (m, i) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'lightbox__rail-thumb';
      btn.setAttribute('aria-label', 'Bild ' + (i + 1));
      var thumbSrc = m.type === 'video' ? (m.poster || m.src) : m.src;
      btn.innerHTML = '<img src="' + thumbSrc + '" alt="" />' +
        (m.type === 'video' ? '<span class="lb-play"><svg viewBox="0 0 24 24"><path d="M8 5v14l11-7z"/></svg></span>' : '');
      btn.addEventListener('click', function () { showMedia(i); });
      lbRail.appendChild(btn);
    });
  }

  function showMedia(idx) {
    lbState.idx = idx;
    lbState.zoom = 0;
    lbState.panX = 0;
    lbState.panY = 0;
    var m = MEDIA[idx];
    if (!m) return;
    videoStoppen();
    if (m.type === 'video') {
      lbMedia.innerHTML = '';
      lbMedia.appendChild(videoAufbauen(m));
      abspielen(lbVid);
    } else {
      lbMedia.innerHTML = '<img src="' + m.src + '" alt="' + (m.alt || '') + '" />';
    }
    Array.from(lbRail.children).forEach(function (c, i) {
      c.classList.toggle('is-active', i === idx);
    });
    applyZoom();
    var active = lbRail.children[idx];
    if (active) try { active.scrollIntoView({ block: 'nearest' }); } catch (e) {}
  }

  // ---- Video in der Lightbox (seit 30.10.2026) ----
  // Läuft stumm als Schleife an, mit eigener ruhiger Bedienung statt der Browser-Leiste
  // (Anhalten unten links). Nur Videos mit geprüftem Ton (data-ton an der Kachel, aus dem
  // Etikett „ton“ im Alt-Text, snippets/gk-video-ton.liquid) bekommen unten rechts
  // „Mit Ton ansehen“: das Video beginnt von vorn, der Ton blendet weich ein, es läuft
  // einmal bis zum Ende und hält dort an, statt mit Ton in Schleife zu laufen. Ton kommt
  // nie von selbst, auch nicht beim nächsten Video oder beim nächsten Besuch. Alle anderen
  // Videos bleiben stumm und lassen sich nicht entstummen: ihr Ton ist nicht geprüft.
  var lbTexte = {
    tonAn: (lb && lb.getAttribute('data-text-ton-an')) || 'Mit Ton ansehen',
    tonAus: (lb && lb.getAttribute('data-text-ton-aus')) || 'Ton aus',
    play: (lb && lb.getAttribute('data-text-play')) || 'Video abspielen',
    pause: (lb && lb.getAttribute('data-text-pause')) || 'Video anhalten'
  };
  var VIDEO_ICON = {
    play: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M8 5v14l11-7z"/></svg>',
    pause: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M7 5h3.5v14H7zM13.5 5H17v14h-3.5z"/></svg>',
    stumm: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3.5 9.25h3.75L12 5v14l-4.75-4.25H3.5z"/>' +
      '<path d="M15.75 9.5l5 5M20.75 9.5l-5 5" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>',
    ton: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3.5 9.25h3.75L12 5v14l-4.75-4.25H3.5z"/>' +
      '<path d="M15.5 9a4.25 4.25 0 0 1 0 6M18.25 6.25a8 8 0 0 1 0 11.5" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>'
  };
  var TON_EINBLENDEN_MS = 700;
  var lbVid = null;              // Video, das gerade in der Lightbox liegt
  var lbVidVersteckt = false;    // angehalten, weil der Tab in den Hintergrund ging

  function abspielen(v) {
    if (!v) return;
    var p = v.play();
    // z. B. Stromsparmodus am iPhone: dann bleibt es beim Knopf „Abspielen“
    if (p && p.catch) p.catch(function () {});
  }

  // iOS lässt die Lautstärke nicht setzen (nur stumm oder laut), dort ohne Einblenden.
  function lautstaerkeSetzbar(v) {
    try {
      var vorher = v.volume;
      v.volume = 0.5;
      var ok = Math.abs(v.volume - 0.5) < 0.01;
      v.volume = vorher;
      return ok;
    } catch (e) { return false; }
  }

  function tonEinblenden(v) {
    var beginn = null;
    function schritt(t) {
      if (v.muted || lbVid !== v) return;
      if (beginn === null) beginn = t;
      var x = Math.min(1, (t - beginn) / TON_EINBLENDEN_MS);
      v.volume = x * x;
      if (x < 1) window.requestAnimationFrame(schritt);
    }
    window.requestAnimationFrame(schritt);
  }

  function tonAn(v) {
    var weich = lautstaerkeSetzbar(v);
    if (weich) v.volume = 0;
    v.loop = false;
    try { v.currentTime = 0; } catch (e) {}
    v.muted = false;
    abspielen(v);
    if (weich) tonEinblenden(v);
  }

  function tonAus(v) {
    var zuEnde = v.ended;
    v.muted = true;
    v.loop = true;
    if (zuEnde) {
      try { v.currentTime = 0; } catch (e) {}
      abspielen(v);
    }
  }

  function videoAufbauen(m) {
    var rahmen = document.createElement('div');
    rahmen.className = 'lb-video';
    var v = document.createElement('video');
    v.muted = true;
    v.defaultMuted = true;
    v.setAttribute('muted', '');
    v.setAttribute('playsinline', '');
    v.loop = true;
    v.preload = 'auto';
    if (m.poster) v.poster = m.poster;
    v.src = m.src;
    rahmen.appendChild(v);

    var play = document.createElement('button');
    play.type = 'button';
    play.className = 'lb-video__knopf lb-video__play';
    rahmen.appendChild(play);

    var ton = null;
    if (m.ton) {
      ton = document.createElement('button');
      ton.type = 'button';
      ton.className = 'lb-video__knopf lb-video__ton';
      rahmen.appendChild(ton);
    }

    var stand = '';
    function zeigen() {
      var laeuft = !v.paused && !v.ended;
      var an = !v.muted;
      var neu = (laeuft ? 'l' : 'p') + (an ? 't' : 's');
      if (neu === stand) return; // volumechange kommt beim Einblenden in jedem Bild
      stand = neu;
      rahmen.classList.toggle('is-paused', !laeuft);
      play.innerHTML = laeuft ? VIDEO_ICON.pause : VIDEO_ICON.play;
      play.setAttribute('aria-label', laeuft ? lbTexte.pause : lbTexte.play);
      if (!ton) return;
      // Ohne Ton mit Text, mit Ton nur noch das Symbol, damit nichts vom Bild ablenkt.
      ton.classList.toggle('is-an', an);
      ton.innerHTML = an ? VIDEO_ICON.ton : VIDEO_ICON.stumm;
      ton.setAttribute('aria-label', an ? lbTexte.tonAus : lbTexte.tonAn);
      if (!an) {
        var text = document.createElement('span');
        text.textContent = lbTexte.tonAn;
        ton.appendChild(text);
      }
    }

    function umschalten() {
      if (v.paused || v.ended) abspielen(v); else v.pause();
    }

    v.addEventListener('click', umschalten);
    play.addEventListener('click', function (e) { e.stopPropagation(); umschalten(); });
    if (ton) {
      ton.addEventListener('click', function (e) {
        e.stopPropagation();
        if (v.muted) tonAn(v); else tonAus(v);
      });
    } else {
      // Ungeprüfter Ton (ältere Videos, Video an der Hand): bleibt stumm wie bisher.
      v.addEventListener('volumechange', function () { if (!v.muted) v.muted = true; });
    }
    ['play', 'pause', 'ended', 'volumechange'].forEach(function (ev) { v.addEventListener(ev, zeigen); });
    zeigen();
    lbVid = v;
    return rahmen;
  }

  function videoStoppen() {
    if (!lbVid) return;
    var v = lbVid;
    lbVid = null;
    lbVidVersteckt = false;
    try { v.pause(); v.removeAttribute('src'); v.load(); } catch (e) {}
  }

  // Tab im Hintergrund: anhalten. Zurück im Tab läuft die stumme Schleife weiter,
  // ein Video mit Ton wartet auf einen Tipp.
  document.addEventListener('visibilitychange', function () {
    if (!lbVid) return;
    if (document.hidden) {
      if (!lbVid.paused) { lbVid.pause(); lbVidVersteckt = true; }
    } else if (lbVidVersteckt) {
      lbVidVersteckt = false;
      if (lbVid.muted) abspielen(lbVid);
    }
  });

  function currentScale() { return ZOOM_STEPS[lbState.zoom] || 1; }

  // Pan so begrenzen, dass das Bild den sichtbaren Bereich nicht ganz verlaesst.
  function clampPan() {
    var scale = currentScale();
    if (scale <= 1) { lbState.panX = 0; lbState.panY = 0; return; }
    var media = lbMedia.firstElementChild; // img oder video
    var baseW = media ? media.offsetWidth : lbMedia.offsetWidth;
    var baseH = media ? media.offsetHeight : lbMedia.offsetHeight;
    var viewW = lbStage ? lbStage.clientWidth : baseW;
    var viewH = lbStage ? lbStage.clientHeight : baseH;
    var maxX = Math.max(0, (baseW * scale - viewW) / 2);
    var maxY = Math.max(0, (baseH * scale - viewH) / 2);
    lbState.panX = Math.max(-maxX, Math.min(maxX, lbState.panX));
    lbState.panY = Math.max(-maxY, Math.min(maxY, lbState.panY));
  }

  function applyTransform() {
    lbMedia.style.transform = 'translate(' + lbState.panX + 'px,' + lbState.panY + 'px) scale(' + currentScale() + ')';
  }

  function applyZoom() {
    clampPan();
    applyTransform();
    if (lbZoomDot) {
      // + ist oben, - ist unten: mehr Zoom -> Punkt wandert nach oben (Richtung +).
      var pct = (lbState.zoom / (ZOOM_STEPS.length - 1)) * 100;
      lbZoomDot.style.top = (100 - pct) + '%';
    }
    lbMedia.style.cursor = currentScale() > 1 ? 'grab' : 'auto';
    lbMedia.style.touchAction = currentScale() > 1 ? 'none' : ''; // Touch-Panning nicht vom Browser kapern lassen
    if (lbZoomIn) lbZoomIn.disabled = lbState.zoom >= ZOOM_STEPS.length - 1;
    if (lbZoomOut) lbZoomOut.disabled = lbState.zoom <= 0;
  }

  function openLightbox(idx) {
    buildRail();
    lb.hidden = false;
    lb.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    kachelnAbgleichen(); // Kachel-Videos halten an, solange die Großansicht offen ist
    showMedia(idx);
  }
  function closeLightbox() {
    lb.hidden = true;
    lb.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    videoStoppen();
    lbMedia.innerHTML = '';
    kachelnAbgleichen();
  }

  if (lbClose) lbClose.addEventListener('click', closeLightbox);
  if (lb) lb.addEventListener('click', function (e) {
    if (e.target === lb || e.target === lbStage) closeLightbox();
  });
  document.addEventListener('keydown', function (e) {
    if (!lb || lb.hidden) return;
    if (e.key === 'Escape') closeLightbox();
    else if (e.key === 'ArrowDown' || e.key === 'ArrowRight') showMedia((lbState.idx + 1) % MEDIA.length);
    else if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') showMedia((lbState.idx - 1 + MEDIA.length) % MEDIA.length);
    else if (e.key === '+' || e.key === '=') { lbState.zoom = Math.min(ZOOM_STEPS.length - 1, lbState.zoom + 1); applyZoom(); }
    else if (e.key === '-') { lbState.zoom = Math.max(0, lbState.zoom - 1); applyZoom(); }
  });
  if (lbZoomIn) lbZoomIn.addEventListener('click', function () {
    lbState.zoom = Math.min(ZOOM_STEPS.length - 1, lbState.zoom + 1);
    applyZoom();
  });
  if (lbZoomOut) lbZoomOut.addEventListener('click', function () {
    lbState.zoom = Math.max(0, lbState.zoom - 1);
    applyZoom();
  });

  // ---- Panning: gezoomtes Bild mit der Maus / dem Finger greifen und verschieben ----
  if (lbMedia) {
    var panning = false, startX = 0, startY = 0, origX = 0, origY = 0;
    lbMedia.addEventListener('pointerdown', function (e) {
      if (currentScale() <= 1) return; // nur sinnvoll, wenn gezoomt
      if (e.target.closest && e.target.closest('button')) return; // Video-Knöpfe bleiben klickbar
      panning = true;
      startX = e.clientX; startY = e.clientY;
      origX = lbState.panX; origY = lbState.panY;
      lbMedia.style.cursor = 'grabbing';
      lbMedia.style.transition = 'none';
      if (e.pointerId != null && lbMedia.setPointerCapture) { try { lbMedia.setPointerCapture(e.pointerId); } catch (_) {} }
      e.preventDefault();
    });
    lbMedia.addEventListener('pointermove', function (e) {
      if (!panning) return;
      lbState.panX = origX + (e.clientX - startX);
      lbState.panY = origY + (e.clientY - startY);
      clampPan();
      applyTransform();
      e.preventDefault();
    });
    var endPan = function () {
      if (!panning) return;
      panning = false;
      lbMedia.style.transition = '';
      lbMedia.style.cursor = currentScale() > 1 ? 'grab' : 'auto';
    };
    lbMedia.addEventListener('pointerup', endPan);
    lbMedia.addEventListener('pointercancel', endPan);
  }

  var lbPrev = document.getElementById('lbPrev');
  var lbNext = document.getElementById('lbNext');
  if (lbPrev) lbPrev.addEventListener('click', function (e) {
    e.stopPropagation();
    showMedia((lbState.idx - 1 + MEDIA.length) % MEDIA.length);
  });
  if (lbNext) lbNext.addEventListener('click', function (e) {
    e.stopPropagation();
    showMedia((lbState.idx + 1) % MEDIA.length);
  });

  // Tile click → Lightbox öffnen (Fotos UND Videos). Videos spielen in der
  // Lightbox mit Steuerung und lassen sich vergrößern wie Fotos. Der Play-Button
  // der Kachel öffnet ebenso die Lightbox (sein Klick blubbert zur Kachel).
  tiles.forEach(function (t, i) {
    t.addEventListener('click', function () { openLightbox(i); });
  });

  // ---- Videos laufen in der Kachel stumm in Schleife (seit 30.10.2026) ----
  // Emil: „Kann das Handwerksvideo und Modellvideo ohne Öffnen im Loop laufen“.
  // Ein Kachel-Video läuft, solange es mindestens zur Hälfte im Bild ist, sonst hält es
  // an; mobil im Karussell läuft so nur das gezeigte. Es pausiert auch, solange die
  // Großansicht offen ist oder der Tab im Hintergrund liegt. Wer am Gerät weniger
  // Bewegung oder Datensparen eingestellt hat, sieht wie bisher Standbild und
  // Play-Knopf; ebenso, wenn der Browser nicht abspielen lässt (Stromsparmodus am
  // iPhone): der Knopf verschwindet erst, wenn das Video wirklich gelaufen ist.
  // Die Kachel bleibt immer stumm, Ton gibt es nur in der Großansicht.
  var kachelVideos = Array.from(tiles).filter(function (t) {
    return t.getAttribute('data-lb-type') === 'video' && t.querySelector('video');
  }).map(function (t) {
    return { kachel: t, video: t.querySelector('video'), sichtbar: false };
  });
  var wenigerBewegung = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
  var datenSparen = !!(navigator.connection && navigator.connection.saveData);

  function schleifeErlaubt() {
    return !datenSparen && !(wenigerBewegung && wenigerBewegung.matches);
  }

  function kachelnAbgleichen() {
    var erlaubt = schleifeErlaubt();
    var darf = erlaubt && !document.hidden && (!lb || lb.hidden);
    kachelVideos.forEach(function (k) {
      if (!erlaubt) k.kachel.classList.remove('is-schleife');
      if (darf && k.sichtbar) { if (k.video.paused) abspielen(k.video); }
      else if (!k.video.paused) k.video.pause();
    });
  }

  if (kachelVideos.length && 'IntersectionObserver' in window) {
    kachelVideos.forEach(function (k) {
      var v = k.video;
      v.muted = true;
      v.addEventListener('playing', function () {
        if (schleifeErlaubt()) k.kachel.classList.add('is-schleife');
      });
      v.addEventListener('volumechange', function () { if (!v.muted) v.muted = true; });
    });
    var kachelBeobachter = new IntersectionObserver(function (eintraege) {
      eintraege.forEach(function (e) {
        kachelVideos.forEach(function (k) {
          if (k.kachel === e.target) k.sichtbar = e.isIntersecting && e.intersectionRatio >= 0.5;
        });
      });
      kachelnAbgleichen();
    }, { threshold: [0, 0.5] });
    kachelVideos.forEach(function (k) { kachelBeobachter.observe(k.kachel); });
    document.addEventListener('visibilitychange', kachelnAbgleichen);
    if (wenigerBewegung) {
      if (wenigerBewegung.addEventListener) wenigerBewegung.addEventListener('change', kachelnAbgleichen);
      else if (wenigerBewegung.addListener) wenigerBewegung.addListener(kachelnAbgleichen);
    }
  }

  // ---- Ring size selector — reads data-delivered-size on .variant container.
  // Liquid renders this attribute from product.metafields.ring.delivery_size.
  // Durchmesser = Umfang / Pi. Bis 08.10.2026 endete die Tabelle bei 64, ein
  // Herrenring in Größe 66 (GK0289) bot dann nur „64“ an, nicht die eigene Größe.
  var SIZE_TABLE = {
    44: 14.0, 45: 14.3, 46: 14.6, 47: 15.0, 48: 15.3, 49: 15.6,
    50: 15.9, 51: 16.2, 52: 16.6, 53: 16.9, 54: 17.2,
    55: 17.5, 56: 17.8, 57: 18.1, 58: 18.5, 59: 18.8,
    60: 19.1, 61: 19.4, 62: 19.7, 63: 20.1, 64: 20.4,
    65: 20.7, 66: 21.0, 67: 21.3, 68: 21.6, 69: 22.0, 70: 22.3
  };
  var variant = document.querySelector('.variant[data-delivered-size]');
  var sel = document.getElementById('ringSizeSelect');
  var caveat = variant ? variant.querySelector('.variant__caveat') : null;
  var caveatCheck = document.getElementById('acceptCustomSize');
  var ctaBtn = document.querySelector('.cta:not(.cta--secondary)');
  if (variant && sel) {
    var delivered = parseInt(variant.getAttribute('data-delivered-size'), 10);
    var range = 2;
    // Beschriftungen kommen aus den Sprachdateien (gk.variant.*) ueber data-Attribute
    // des .variant-Containers (unikat-variant.liquid / serie-variant.liquid); die
    // deutschen Fallbacks greifen nur ohne Attribute.
    var decimal = variant.getAttribute('data-decimal') || ',';
    var labelCurrent = variant.getAttribute('data-label-current') || ' – Aktuelle Größe';
    var labelOther = variant.getAttribute('data-label-other') || 'Andere Größe — bitte im Warenkorb-Notizfeld eintragen';
    var msgConfirm = variant.getAttribute('data-msg-confirm') || 'Bitte die individuelle Maßanfertigung bestätigen.';
    sel.innerHTML = '';
    for (var s = delivered - range; s <= delivered + range; s++) {
      var dia = SIZE_TABLE[s];
      if (dia === undefined) continue;
      var label = s + ' (Ø ' + dia.toFixed(1).replace('.', decimal) + ' mm)';
      if (s === delivered) label += labelCurrent;
      var opt = document.createElement('option');
      opt.value = String(s);
      opt.textContent = label;
      if (s === delivered) { opt.setAttribute('data-delivered', '1'); opt.selected = true; }
      sel.appendChild(opt);
    }
    var other = document.createElement('option');
    other.value = 'andere';
    other.textContent = labelOther;
    sel.appendChild(other);

    function updateCaveat() {
      if (!caveat) return;
      var val = sel.value;
      var changed = val !== '' && val !== String(delivered);
      caveat.hidden = !changed;
      if (!changed && caveatCheck) caveatCheck.checked = false;
      updateCtaState();
    }
    function updateCtaState() {
      if (!ctaBtn) return;
      var needsAck = caveat && !caveat.hidden;
      var ok = !needsAck || (caveatCheck && caveatCheck.checked);
      ctaBtn.disabled = !ok;
      ctaBtn.setAttribute('aria-disabled', String(!ok));
      ctaBtn.title = ok ? '' : msgConfirm;
    }
    updateCaveat();
    sel.addEventListener('change', updateCaveat);
    if (caveatCheck) caveatCheck.addEventListener('change', updateCtaState);
  }

  // ---- Armband-Längen-Selector — liest data-delivered-length auf .variant.
  // Kleiner kostenfrei, bis +2 cm kostenfrei (Emil 17.06.2026). Logik analog Ring.
  var bVariant = document.querySelector('.variant[data-delivered-length]');
  var bSel = document.getElementById('braceletLengthSelect');
  var bCaveat = bVariant ? bVariant.querySelector('.variant__caveat') : null;
  var bCaveatCheck = document.getElementById('acceptCustomLength');
  var bCtaBtn = document.querySelector('.cta:not(.cta--secondary)');
  if (bVariant && bSel) {
    var dLen = parseFloat(bVariant.getAttribute('data-delivered-length'));
    var bDecimal = bVariant.getAttribute('data-decimal') || ',';
    var bLabelOther = bVariant.getAttribute('data-label-other') || 'Größere Länge — bitte im Warenkorb-Notizfeld eintragen';
    if (!isNaN(dLen)) {
      bSel.innerHTML = '';
      for (var L = dLen - 4; L <= dLen + 2 + 0.001; L += 0.5) {
        if (L <= 0) continue;
        var isDel = Math.abs(L - dLen) < 0.01;
        var cm = (Math.round(L * 10) % 10 === 0) ? String(Math.round(L)) : (Math.round(L * 10) / 10).toString().replace('.', bDecimal);
        var bo = document.createElement('option');
        bo.value = cm + ' cm';
        bo.textContent = cm + ' cm';
        if (isDel) { bo.setAttribute('data-delivered', '1'); bo.selected = true; }
        bSel.appendChild(bo);
      }
      var bOther = document.createElement('option');
      bOther.value = 'andere';
      bOther.textContent = bLabelOther;
      bSel.appendChild(bOther);

      function bUpdate() {
        if (!bCaveat) return;
        var o = bSel.options[bSel.selectedIndex];
        var changed = o && o.value !== '' && !o.hasAttribute('data-delivered');
        bCaveat.hidden = !changed;
        if (!changed && bCaveatCheck) bCaveatCheck.checked = false;
        if (bCtaBtn) {
          var ok = !changed || (bCaveatCheck && bCaveatCheck.checked);
          bCtaBtn.disabled = !ok;
          bCtaBtn.setAttribute('aria-disabled', String(!ok));
        }
      }
      bUpdate();
      bSel.addEventListener('change', bUpdate);
      if (bCaveatCheck) bCaveatCheck.addEventListener('change', bUpdate);
    }
  }

  // ---- Versprechen-Aufklapper: ganze Zeile klickbar ----
  document.querySelectorAll('.trust-list__expand').forEach(function (li) {
    var details = li.querySelector('details');
    if (!details) return;
    li.addEventListener('click', function (e) {
      if (e.target.closest('details > p')) return;
      if (e.target.closest('summary')) return;
      details.open = !details.open;
    });
  });

  // ---- Mobile Galerie-Punkte + Pfeile ----
  (function () {
    var gallery = document.getElementById('gallery');
    var dots = document.getElementById('galleryDots');
    var prevBtn = document.getElementById('galleryPrev');
    var nextBtn = document.getElementById('galleryNext');
    if (!gallery || !dots) return;
    var tilesEls = gallery.querySelectorAll('.tile');
    dots.innerHTML = '';
    tilesEls.forEach(function (_, i) {
      var d = document.createElement('span');
      d.className = 'gallery-dots__dot' + (i === 0 ? ' is-active' : '');
      dots.appendChild(d);
    });
    function currentIndex() {
      var w = gallery.clientWidth;
      if (!w) return 0;
      return Math.max(0, Math.min(tilesEls.length - 1, Math.round(gallery.scrollLeft / w)));
    }
    function updateArrows(idx) {
      if (prevBtn) prevBtn.disabled = idx <= 0;
      if (nextBtn) nextBtn.disabled = idx >= tilesEls.length - 1;
    }
    function goTo(idx) {
      idx = Math.max(0, Math.min(tilesEls.length - 1, idx));
      var w = gallery.clientWidth;
      gallery.scrollTo({ left: idx * w, behavior: 'smooth' });
    }
    if (prevBtn) prevBtn.addEventListener('click', function () { goTo(currentIndex() - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goTo(currentIndex() + 1); });
    updateArrows(0);
    var raf = null;
    gallery.addEventListener('scroll', function () {
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        var idx = currentIndex();
        for (var i = 0; i < dots.children.length; i++) {
          dots.children[i].classList.toggle('is-active', i === idx);
        }
        updateArrows(idx);
      });
    }, { passive: true });
  })();

  // ---- Tabs ----
  var tabBtns = document.querySelectorAll('.tabs__btn');
  var tabPanels = document.querySelectorAll('.tabs__panel');
  function selectTab(name) {
    tabBtns.forEach(function (b) { b.classList.toggle('is-active', b.getAttribute('data-tab') === name); });
    tabPanels.forEach(function (p) { p.classList.toggle('is-active', p.getAttribute('data-panel') === name); });
  }
  tabBtns.forEach(function (b) {
    b.addEventListener('click', function () { selectTab(b.getAttribute('data-tab')); });
  });
  document.querySelectorAll('[data-tab]').forEach(function (el) {
    if (el.classList.contains('tabs__btn')) return;
    el.addEventListener('click', function (e) {
      e.preventDefault();
      selectTab(el.getAttribute('data-tab'));
      var tabsSection = document.getElementById('tabs');
      if (tabsSection) tabsSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });
})();

/* ---- Sticky-Buybox: eigene Höhe als CSS-Var pflegen ----
   Die .buybox-Sticky-Regel in produktseite-unikat.css braucht die Boxhöhe
   (--buybox-h), um zwischen Oben-Pinnen (Box passt in den Viewport) und
   Unterkante-Pinnen (Box ist höher) umzuschalten. ResizeObserver für
   Laufzeit-Änderungen (Variantenwahl, nachladendes eTrusted-Widget);
   load/resize/toggle zusätzlich, weil RO-Callbacks in gedrosselten
   Hintergrund-Tabs ausbleiben können ('toggle' der Details bubbelt nicht,
   daher capture). */
(function () {
  var buybox = document.getElementById('buybox');
  if (!buybox) return;
  var update = function () {
    buybox.style.setProperty('--buybox-h', buybox.offsetHeight + 'px');
  };
  if ('ResizeObserver' in window) new ResizeObserver(update).observe(buybox);
  window.addEventListener('load', update);
  window.addEventListener('resize', update);
  buybox.addEventListener('toggle', update, true);
  update();
})();

/* ---- Kaufleiste (nur Handy): Preis und Kaufknopf im ersten Bildschirm ----
   Clarity-Auswertung 03.11.2026 (~/Goldschmiede/clarity-auswertung-2026-11-03.md): auf dem
   Handy füllt die Galerie den ersten Bildschirm, die Hälfte der Besucher scrollt nie bis zum
   Preis (346 Aufrufe: 51 % kommen bis zum Titel, 28 % bis zum Knopf). Die Leiste spiegelt den Preisblock und den echten .cta der Buybox (Unikat und Serie,
   produktseite-serie.js schreibt den Variantenpreis in .price-block__amount, der Spiegel
   zieht nach). Ein Tipp auf den Knopf löst den echten Knopf aus (Warenkorb-Formular bzw.
   Anfrage-Mail); ist er gesperrt (Größe noch nicht bestätigt), scrollt sie zur Auswahl.
   Sichtbar nur, solange der echte Knopf nicht im Bild ist; weg bei Großansicht, Warenkorb,
   Suche und offenem Chat. Verkauft, reserviert oder ausverkauft: keine Leiste. */
(function () {
  var buybox = document.getElementById('buybox');
  var preis = document.querySelector('#buybox .price-block__amount');
  var cta = document.querySelector('#buybox .cta:not(.cta--secondary)');
  if (!buybox || !preis || !cta || !('IntersectionObserver' in window) || !('MutationObserver' in window)) return;
  // Ausverkaufte Serie (data-purchasable der Buybox, produktseite-serie.js schaltet den Knopf
  // erst später): dort gibt es nur die Warteliste, keine Leiste.
  if (cta.disabled || cta.getAttribute('aria-disabled') === 'true' || buybox.getAttribute('data-purchasable') === 'false') return;
  var mobil = window.matchMedia('(max-width: 820px)');
  var anfrage = cta.classList.contains('cta--anfrage');

  var leiste = document.createElement('div');
  leiste.className = 'gk-kaufleiste' + (anfrage ? ' gk-kaufleiste--nur-knopf' : '');
  var preisBox = document.createElement('div');
  preisBox.className = 'gk-kaufleiste__preis';
  var betrag = document.createElement('span');
  betrag.className = 'gk-kaufleiste__betrag';
  preisBox.appendChild(betrag);
  var metaQuelle = document.querySelector('#buybox .price-block__meta');
  if (metaQuelle) {
    var meta = document.createElement('span');
    meta.className = 'gk-kaufleiste__meta';
    meta.textContent = metaQuelle.textContent.replace(/\s+/g, ' ').trim();
    preisBox.appendChild(meta);
  }
  var knopf = document.createElement('button');
  knopf.type = 'button';
  knopf.className = 'cta gk-kaufleiste__knopf' + (anfrage ? ' cta--anfrage' : '');
  if (!anfrage) leiste.appendChild(preisBox);
  leiste.appendChild(knopf);
  document.body.appendChild(leiste);

  function text(el) { return el.textContent.replace(/\s+/g, ' ').trim(); }
  function spiegeln() {
    betrag.textContent = text(preis);
    knopf.textContent = text(cta);
    var gesperrt = cta.disabled || cta.getAttribute('aria-disabled') === 'true';
    knopf.setAttribute('aria-disabled', String(gesperrt));
    knopf.title = gesperrt ? (cta.title || '') : '';
  }
  spiegeln();
  var spiegel = new MutationObserver(spiegeln);
  spiegel.observe(preis, { childList: true, characterData: true, subtree: true });
  spiegel.observe(cta, { childList: true, characterData: true, subtree: true, attributes: true, attributeFilter: ['disabled', 'aria-disabled', 'title'] });

  knopf.addEventListener('click', function () {
    var gesperrt = cta.disabled || cta.getAttribute('aria-disabled') === 'true';
    if (gesperrt) {
      // Größe oder Bestätigung fehlt: zur Auswahl in der Buybox, dort steht der Hinweis.
      buybox.scrollIntoView({ behavior: 'smooth', block: 'start' });
      var auswahl = buybox.querySelector('select, input[type="checkbox"]:not(:checked)');
      if (auswahl) setTimeout(function () { try { auswahl.focus({ preventScroll: true }); } catch (e) {} }, 450);
      return;
    }
    cta.click();
  });

  var ctaImBild = false;
  function ueberlagert() {
    return !!document.querySelector('#lightbox:not([hidden]), .theme-ajax-cart.is-visible, .show-mini-cart, .search-overlay.is-opened, .fancybox-is-open, shopify-chat[open]');
  }
  function aktualisieren() {
    var an = mobil.matches && !ctaImBild && !ueberlagert();
    leiste.classList.toggle('is-sichtbar', an);
    if ('inert' in leiste) leiste.inert = !an;
    document.body.classList.toggle('gk-kaufleiste-an', an);
    if (an) document.body.style.setProperty('--gk-kaufleiste-h', leiste.offsetHeight + 'px');
  }
  // Der untere Rand des Sichtbereichs zählt um die Leistenhöhe gekürzt: steht der echte
  // Knopf nur hinter der Leiste, gilt er als nicht im Bild.
  new IntersectionObserver(function (eintraege) {
    eintraege.forEach(function (e) { ctaImBild = e.isIntersecting; });
    aktualisieren();
  }, { threshold: 0, rootMargin: '0px 0px -72px 0px' }).observe(cta);
  new MutationObserver(aktualisieren).observe(document.body, { attributes: true, attributeFilter: ['class', 'hidden', 'open'], subtree: true });
  if (mobil.addEventListener) mobil.addEventListener('change', aktualisieren);
  else if (mobil.addListener) mobil.addListener(aktualisieren);
  window.addEventListener('resize', aktualisieren);
  aktualisieren();
})();
